import styled, { createGlobalStyle } from 'styled-components';
import colors from '@designSystem/colors';
import breakpoints from '@designSystem/breakpoints';

export const GlobalStyle = createGlobalStyle`
  html, body, div#root  {
    background: ${colors.lighterGrey};
  }
`;

export const GreyBackground = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 324px;

  @media (max-width: ${breakpoints.large}) {
    padding-top: 136px;
  }
`;

export const TableContainer = styled.div`
  margin: 3px 64px;

  @media (max-width: ${breakpoints.large}) {
    margin: 0px 16px;
  }
`;

export const StickyContainer = styled.div`
  position: fixed;

  background-color: ${colors.lighterGrey};
  width: 100%;
  height: auto;
  z-index: 10;
  top: 0px;
  padding: 0px 64px 16px;

  @media (max-width: ${breakpoints.large}) {
    padding: 0px 16px 8px 16px;
  }
`;
